import { createAsyncThunk } from '@reduxjs/toolkit';
import priceItemApi from '~/apis/priceItem';
import { CREATE_PRICE_ITEM, EDIT_PRICE_ITEM, GET_PRICES_ITEM, GET_PRICE_ITEM } from '~/utils/constants/actionType';
import { IParamsGetPriceComponent } from '~/utils/interface/estimate';
import { IBodyCreatePriceItem, IPriceItem, IResponseGetPriceItem } from '~/utils/interface/priceItem';

export const handleCreatePriceItem = createAsyncThunk<IPriceItem, IBodyCreatePriceItem>(
  CREATE_PRICE_ITEM,
  async (data: IBodyCreatePriceItem, { rejectWithValue }) => {
    try {
      const res = await priceItemApi.createPriceItem(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetPriceItems = createAsyncThunk<IResponseGetPriceItem, IParamsGetPriceComponent>(
  GET_PRICES_ITEM,
  async (params: IParamsGetPriceComponent = {}, { rejectWithValue }) => {
    try {
      const res = await priceItemApi.getPriceListItem(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetPriceItem = createAsyncThunk<IPriceItem, string>(
  GET_PRICE_ITEM,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await priceItemApi.getPriceItem(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditPriceItem = createAsyncThunk<IPriceItem, { id: string; params: IBodyCreatePriceItem }>(
  EDIT_PRICE_ITEM,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await priceItemApi.updatePriceItem(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
